import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { BillingAddressComponent } from '../components/billing-address.component';
import storePersist from '../../../redux/storePersist';

export const BillingAddressContainer = ({ onInnerFormChange, selectBillingAddress,isAddress }: any) => {
  const [
    stateValues,
    setStateValues
  ] = useState<any>([])

  const handleFilterToStates = (event: any) => {
    onInnerFormChange(
      event,
      'BillingAddress.CountryId',
      selectBillingAddress?.BillingAddress
    );

    if (event) {
      const filterStates: any = R.filter(
        (value: any) => value.CountryId === event,
        statesItems
      );
      if (filterStates.length) {
        setStateValues(filterStates);
      } else {
        setStateValues(statesItems);
      }
    } else {
      setStateValues([])
    }
  }

useEffect(() => {
  if(selectBillingAddress?.BillingAddress?.CountryId){
    handleFilterToStates(selectBillingAddress?.BillingAddress?.CountryId)
  }
 
}, [])

const statesItems = storePersist?.get("states")?.current?.items;
const countriesItems = storePersist?.get("countries")?.current?.items;
const librariesItems = storePersist?.get("library")?.current;

  return (
        <BillingAddressComponent
        isAddress={isAddress}
            onFilterToStates={handleFilterToStates}
            onInnerFormChange={onInnerFormChange}
            selectBillingAddress={selectBillingAddress}
            countries={countriesItems}
            stateValues={stateValues}
            libraries={librariesItems}
        />
  )
}
